// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__2GWmv","image":"App_image__2fSTW","credits":"App_credits__2J9ZV","logoimg":"App_logoimg__3UjgN"};